'use client';

import { Branch } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { BranchSocialNetwork } from './branch-social-network.component';
import { BranchContact } from './branch-contact.component';

import { AnalyticsBranchPageEnum } from '@/app/(main)/(pages)/_enums/analytics-branch-page.enum';
import { Card } from '@/components/ui/card.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { cn } from '@/utils/cn-tw-merge';

interface BranchCardContactProps extends React.HTMLAttributes<HTMLDivElement> {
  branch: Branch;
  pageFrom: AnalyticsBranchPageEnum;
}

export const BranchCardContact = ({ branch, className, pageFrom }: BranchCardContactProps) => {
  if (!branch?.email && (!branch?.phones || branch.phones.length === 0) && !branch?.whatsapp) {
    return null;
  }

  return (
    <Card
      data-testid={DataTestIdEnum.BRANCH_CONTACT_INFORMATION_CARD}
      className={cn(className, 'border-0 p-0 w-full mt-3 md:mt-0 md:border md:border-gray-300 md:p-6')}
    >
      <Typography
        variant={TypographyVariant.MEDIUM_SUBTITLE}
        className="font-semibold mb-4"
      >
        Contatos
      </Typography>
      <div className="flex flex-col gap-4">
        <BranchContact branch={branch} pageFrom={pageFrom} />

        <BranchSocialNetwork branch={branch} />
      </div>
    </Card>
  );
};
